import { Route, Routes } from "react-router-dom";
import React from "react";
import Navbar from "./components/Navbar";
import Main from "./pages/Main";
import Cal from "./pages/Cal";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<><Navbar/><Main/></>}/>
        <Route exact path="/Contact" element={<><Cal/></>}/>
      </Routes>
    </>
  );
}

export default App;
